import { Capacitor } from '@capacitor/core';

/**
 * ¿Decide algo `navigator.permissions.query()` en esta plataforma?
 *
 * ── En el navegador, sí ────────────────────────────────────────────────────
 *
 * El permiso se guarda por origen, así que la respuesta ES la decisión del
 * usuario. Preguntar ANTES de usar la cámara o el GPS permite avisar con un
 * mensaje útil ("desbloquéalo en la barra de direcciones") en vez de dejar un
 * visor roto o un modal que no reacciona.
 *
 * ── Dentro del APK, no ─────────────────────────────────────────────────────
 *
 * En el WebView de Capacitor quien manda es el permiso de la APLICACIÓN, y las
 * peticiones bajan al código nativo (`onPermissionRequest` para la cámara,
 * `onGeolocationPermissionsShowPrompt` para la ubicación), que pide el permiso
 * de Android y enseña el diálogo del sistema.
 *
 * Que la Permissions API no puede reflejar eso no es una sospecha: Capacitor
 * concede el origen con `callback.invoke(origin, true, false)` — ese último
 * `false` es `retain`, o sea que **el WebView no guarda nada**. No hay estado
 * por origen que consultar, así que lo que devuelva `query()` es un valor por
 * defecto, no una decisión.
 *
 * Y tratar ese valor como una negativa tiene una consecuencia concreta:
 * cortamos el flujo ANTES de la llamada que haría salir el diálogo de Android,
 * así que el diálogo no sale NUNCA. La función queda muerta sin que nadie haya
 * denegado nada — y el usuario ve un "permiso denegado" que él no ha decidido.
 *
 * ── Qué hacer entonces en nativo ───────────────────────────────────────────
 *
 * Dejar que lo decida el sistema: llamar y atender el fallo. No se pierde el
 * aviso, porque el rechazo real llega igual por la vía de siempre
 * (`NotAllowedError` en la cámara, `code === 1` en la geolocalización).
 */
export function permissionApiDecides(): boolean {
  return !Capacitor.isNativePlatform();
}

export default permissionApiDecides;
